<template>
	<div class="text-sm text-gray-500 mt-8 pt-2 border-t">
		<slot />
	</div>
</template>